var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4711 4.47132C12.7314 4.21097 12.7314 3.78886 12.4711 3.52851C12.2107 3.26816 11.7886 3.26816 11.5283 3.52851L7.99967 7.05711L4.47108 3.52851C4.21073 3.26816 3.78862 3.26816 3.52827 3.52851C3.26792 3.78886 3.26792 4.21097 3.52827 4.47132L7.05687 7.99992L3.52827 11.5285C3.26792 11.7889 3.26792 12.211 3.52827 12.4713C3.78862 12.7317 4.21073 12.7317 4.47108 12.4713L7.99967 8.94273L11.5283 12.4713C11.7886 12.7317 12.2107 12.7317 12.4711 12.4713C12.7314 12.211 12.7314 11.7889 12.4711 11.5285L8.94248 7.99992L12.4711 4.47132Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose2);
export default __webpack_public_path__ + "static/media/close2.969f2a325726facd4c1335ef7a0809e7.svg";
export { ForwardRef as ReactComponent };